export default __webpack_public_path__ + "static/media/popup_industry_stat_1-2.34bb495a.png";